import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { get } from 'lodash'
import { FilterAjTemplates } from 'containers/filters'
import { Table, Data } from 'components/layout/Table'
import { BadgesLevels } from 'components/misc'
import { ajTemplates as ajTemplatesLayout } from 'constants/layout'
import { apiAjTemplates } from 'helpers/decorators/api'
import { meta, tableCommon } from 'helpers/decorators'
import config from 'config'

@meta({
  title: 'My Organization - AJ templates',
  intlKey: 'pageTitle.my_organization_templates'
})
@apiAjTemplates({
  list: true,
  useCommonLimit: true
})
@tableCommon()
class AjEventTemplates extends Component {
  static propTypes = {
    setAjTemplatesParams: PropTypes.func.isRequired,
    ajTemplates: PropTypes.object.isRequired,
    setCommonLimit: PropTypes.func
  }

  render() {
    const {
      ajTemplates: { loading, list, offset, limit, pages, sort },
      setAjTemplatesParams,
      setCommonLimit
    } = this.props

    return (
      <div>
        <FilterAjTemplates />
        <Table
          loading={loading}
          length={list.length}
          offset={offset}
          limit={limit}
          onSetLimit={setCommonLimit}
          pages={pages}
          sort={sort}
          ths={ajTemplatesLayout.tableHeaders}
          setParams={setAjTemplatesParams}
        >
          <Data>
            {list.map((item, index) => (
              <tr key={index}>
                <td>
                  <Link to={`${config.publicPath}/adventurous-journeys/templates/${item.id}`}>
                    {item.id}
                  </Link>
                </td>
                <td>{get(item, 'ajEventCategory.translationText')}</td>
                <td>{get(item, 'activityCategory.translatedName')}</td>
                <td>{get(item, 'activityCategory.parent.translatedName')}</td>
                <td><BadgesLevels levels={[item]} /></td>
                <td>
                  {get(item, 'location')}
                  {' '}
                  {get(item, 'country.name') && `, ${item.country.name}`}
                </td>
                <td>---</td>
              </tr>
            ))}
          </Data>
        </Table>
      </div>
    )
  }
}

export default AjEventTemplates
